import React from 'react';
import { Box, Button } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PatientWorkspaceTabs from './PatientWorkspaceTabs';

export default function PatientWorkspaceNavigation({ value, onChange, sophieOpen, onToggleSophie, children }) {
  return <>
    <Box sx={{ minWidth: 0, flex: '1 1 400px' }}><PatientWorkspaceTabs value={value} onChange={onChange} /></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5 }}>
      <Button
        onClick={onToggleSophie}
        aria-expanded={sophieOpen}
        aria-controls="sophie-assistant"
        variant="contained"
        startIcon={<AutoAwesomeIcon sx={{ fontSize: 16 }} />}
        sx={{
          background: sophieOpen
            ? 'linear-gradient(90deg, #7C3AED 0%, #9D5CF5 100%)'
            : 'linear-gradient(90deg, #29C0BB 0%, #1ca8a4 100%)',
          '&:hover': {
            background: sophieOpen
              ? 'linear-gradient(90deg, #6D28D9 0%, #8B5CF6 100%)'
              : 'linear-gradient(90deg, #1ca8a4 0%, #158a87 100%)',
          },
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 600,
          px: 2.5,
          boxShadow: 'none',
          flexShrink: 0,
        }}
      >
        {sophieOpen ? 'Close Sophie' : 'Ask Sophie'}
      </Button>
      {children}
    </Box>
  </>;
}
